export const siteInfo = {
  name: "073漫画网",
  slogan: "老漫画补档 · 经典老番考古",
  description:
    "073漫画网专注老漫画补档与经典老番考古，收录童年漫画、怀旧漫与绝版资源，按年代与题材整理，帮你找回记忆中的老漫画，补完当年没看完的旧坑。",
  email: "service@073manga.net",
};

export const eraList = [
  {
    id: "80s",
    title: "80后童年",
    subtitle: "记忆里的卷纸漫",
    desc: "铁皮机器人、热血少年与初代国漫，翻开就是满满的年代感。",
    count: 186,
    img: "https://readdy.ai/api/search-image?query=retro%201980s%20chinese%20shounen%20manga%20comic%20cover%20style%20bold%20ink%20lineart%20vintage%20warm%20faded%20orange%20and%20brown%20tones%20old%20newspaper%20print%20texture%20nostalgic%20childhood%20classic%20cartoon%20poster&width=800&height=1000&seq=era-80s&orientation=portrait",
    tags: ["机器人", "热血", "国漫"],
  },
  {
    id: "90s",
    title: "90后童年",
    subtitle: "校门口的小人书",
    desc: "魔法、剑客、冒险与放学后的约定，装满了课桌抽屉的秘密。",
    count: 243,
    img: "https://readdy.ai/api/search-image?query=retro%201990s%20japanese%20shounen%20manga%20comic%20cover%20nostalgic%20school%20boy%20sword%20adventure%20warm%20faded%20yellow%20and%20red%20colors%20old%20paper%20texture%20classic%20vintage%20cartoon%20poster&width=800&height=1000&seq=era-90s&orientation=portrait",
    tags: ["冒险", "剑客", "日漫"],
  },
  {
    id: "00s",
    title: "00后童年",
    subtitle: "动画城与四格漫",
    desc: "魔法少女、搞笑日常与连载时代的余晖，承包了整个夏天。",
    count: 157,
    img: "https://readdy.ai/api/search-image?query=2000s%20cute%20retro%20anime%20manga%20style%20comic%20cover%20magical%20girl%20slice%20of%20life%20soft%20warm%20pastel%20faded%20vintage%20look%20old%20paper%20texture%20childhood%20classic%20cartoon%20poster&width=800&height=1000&seq=era-00s&orientation=portrait",
    tags: ["魔法", "搞笑", "日常"],
  },
];

export const hotWorks = [
  {
    id: "hw-01",
    title: "放学后的星空",
    author: "沈知夏",
    year: "1996",
    era: "90后童年",
    genre: "校园 · 奇幻",
    status: "已补全",
    img: "https://readdy.ai/api/search-image?query=retro%201990s%20manga%20cover%20dusk%20school%20campus%20under%20starry%20sky%20boy%20and%20girl%20silhouette%20warm%20faded%20orange%20blue%20vintage%20paper%20texture%20nostalgic%20classic%20comic&width=600&height=800&seq=hw-01&orientation=portrait",
  },
  {
    id: "hw-02",
    title: "铁皮机器人小侠",
    author: "郑铁民",
    year: "1989",
    era: "80后童年",
    genre: "科幻 · 热血",
    status: "绝版修复",
    img: "https://readdy.ai/api/search-image?query=retro%201980s%20tin%20robot%20hero%20sci%20fi%20manga%20cover%20bold%20ink%20lineart%20warm%20rust%20orange%20tones%20old%20paper%20grain%20vintage%20childhood%20classic%20comic&width=600&height=800&seq=hw-02&orientation=portrait",
  },
  {
    id: "hw-03",
    title: "魔法水彩笔",
    author: "林小满",
    year: "2003",
    era: "00后童年",
    genre: "魔法 · 治愈",
    status: "连载中",
    img: "https://readdy.ai/api/search-image?query=2000s%20magical%20paintbrush%20girl%20manga%20cover%20cute%20retro%20anime%20style%20soft%20warm%20pastel%20colors%20watercolor%20old%20paper%20texture%20nostalgic%20classic%20comic&width=600&height=800&seq=hw-03&orientation=portrait",
  },
  {
    id: "hw-04",
    title: "剑风书童",
    author: "顾长歌",
    year: "1994",
    era: "90后童年",
    genre: "武侠 · 冒险",
    status: "已补全",
    img: "https://readdy.ai/api/search-image?query=retro%201990s%20wuxia%20sword%20youth%20manga%20cover%20ink%20brush%20lineart%20warm%20sepia%20and%20crimson%20faded%20old%20paper%20texture%20nostalgic%20classic%20comic&width=600&height=800&seq=hw-04&orientation=portrait",
  },
  {
    id: "hw-05",
    title: "巷口小卖部",
    author: "马晓东",
    year: "1998",
    era: "90后童年",
    genre: "日常 · 温馨",
    status: "已补全",
    img: "https://readdy.ai/api/search-image?query=retro%201990s%20slice%20of%20life%20manga%20cover%20corner%20store%20street%20warm%20faded%20yellow%20green%20vintage%20paper%20grain%20nostalgic%20childhood%20classic%20comic&width=600&height=800&seq=hw-05&orientation=portrait",
  },
  {
    id: "hw-06",
    title: "星海列车",
    author: "苏明澈",
    year: "2001",
    era: "00后童年",
    genre: "冒险 · 奇幻",
    status: "考古更新",
    img: "https://readdy.ai/api/search-image?query=2000s%20space%20train%20fantasy%20adventure%20manga%20cover%20retro%20anime%20style%20warm%20violet%20teal%20faded%20old%20paper%20texture%20nostalgic%20classic%20comic&width=600&height=800&seq=hw-06&orientation=portrait",
  },
];

export const rareResources = [
  {
    id: "rr-01",
    title: "《童话大王》早期合订本",
    desc: "1987—1992 年试刊期合订本扫描修复，包含多篇难觅的短篇与专栏。",
    source: "扫描版 · 高清",
    year: "1987-1992",
    status: "可补档",
  },
  {
    id: "rr-02",
    title: "《少年漫画》创刊号",
    desc: "90 年代知名刊物创刊号完整收录，封面与扉页高清修复，还原当年质感。",
    source: "扫描版 · 绝版",
    year: "1991",
    status: "限量",
  },
  {
    id: "rr-03",
    title: "国产动画分镜手稿集",
    desc: "多位老动画人的早期分镜与设定稿，逐页整理成专题资料，供考古研究。",
    source: "图文 · 专题",
    year: "1980s-90s",
    status: "整理中",
  },
  {
    id: "rr-04",
    title: "《少年科学画报》旧刊",
    desc: "70 年代末至 90 年代初旧刊补档，科普连载与连环画栏目完整归档。",
    source: "扫描版 · 高清",
    year: "1979-1995",
    status: "可补档",
  },
];

export const archiveSpecials = [
  {
    id: "ar-01",
    title: "九十年代卷纸漫考古",
    desc: "那些印在报纸边角、卷纸上的短篇漫画，是我们最早接触的连载。",
    posts: 42,
    img: "https://readdy.ai/api/search-image?query=vintage%201990s%20newspaper%20comic%20strip%20clippings%20collage%20old%20papers%20glued%20on%20desk%20warm%20sepia%20faded%20yellow%20vintage%20archive%20research%20nostalgic%20retro&width=800&height=500&seq=ar-01&orientation=landscape",
  },
  {
    id: "ar-02",
    title: "国漫黄金年代的漫画家",
    desc: "走访当年连载在期刊上的老漫画家，聊一聊笔下的江湖与少年。",
    posts: 27,
    img: "https://readdy.ai/api/search-image?query=retro%20manga%20artist%20drawing%20desk%20old%20ink%20brush%20and%20sketches%20warm%20lamp%20light%20vintage%20studio%20nostalgic%20warm%20brown%20tones%20archive%20documentary&width=800&height=500&seq=ar-02&orientation=landscape",
  },
  {
    id: "ar-03",
    title: "旧书店里寻回的绝版漫",
    desc: "在各地旧书店、跳蚤市场里寻回那些绝版单行本与散页的完整记录。",
    posts: 33,
    img: "https://readdy.ai/api/search-image?query=old%20bookstore%20stack%20of%20vintage%20manga%20volumes%20warm%20dusty%20shelves%20golden%20afternoon%20light%20nostalgic%20warm%20amber%20tones%20rare%20book%20collection%20retro&width=800&height=500&seq=ar-03&orientation=landscape",
  },
];

export const testimonials = [
  {
    id: "t-01",
    name: "老猫不吃鱼",
    role: "80后 · 上海",
    text: "在这里找到了小时候订的那本《少年漫画》，创刊号扫描得特别清楚，像翻开回忆一样，太感动了。",
  },
  {
    id: "t-02",
    name: "苏打气泡",
    role: "90后 · 成都",
    text: "补档页做得干净利落，按年代翻很方便，把当年没看完的《放学后的星空》一口气追完了。",
  },
  {
    id: "t-03",
    name: "小早川",
    role: "00后 · 广州",
    text: "作为新入坑的怀旧漫爱好者，这里的年代专题和考古资料帮我补了很多课，条理特别清楚。",
  },
];

export const faqList = [
  {
    q: "073漫画网收录哪些类型的老漫画？",
    a: "073漫画网专注怀旧漫与经典老番补档，收录 80、90、00 年代的童年漫画、考古漫与绝版资源，覆盖武侠、科幻、魔法、校园、日常等多种题材，并按年代和题材分门别类整理。",
  },
  {
    q: "我想找一部记不清名字的童年漫画，该怎么办？",
    a: "你可以先根据大概的年代和题材在年代专题里翻看；如果还是找不到，可以在页底的补档请求表单里描述剧情和人物特征，我们会尽力帮你寻回并整理入库。",
  },
  {
    q: "绝版资源区的扫描件质量如何？",
    a: "绝版资源区的扫描件经过逐页去灰、裁边和清晰度修复，尽量还原当年纸刊质感，同时标注了来源与年份，方便考古研究参考。",
  },
  {
    q: "网站会持续更新新的老漫画补档吗？",
    a: "会的。我们持续从旧书店、收藏者和原刊渠道收集补档素材，每周都会更新年代专题与绝版资源，也欢迎你通过补档表单反馈想看的旧坑。",
  },
  {
    q: "补档的老漫画是否收费？",
    a: "073漫画网的在线浏览与年代资料完全免费开放。绝版扫描件的高清版本会标注获取方式，但基础内容始终免费。",
  },
];